import request from 'local_modules/request'
import { constants, modals, convertPrice } from 'helpers'
import { reducers, getState } from 'redux/core'
import actions from 'redux/actions'


const setFetching = (isFetching) => reducers.marketplace.adminTicketPage.setFetching(isFetching)

const setTickets = (tickets) => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  const newTickets = convertPrice.fromRub(tickets)

  return request.post(constants.marketplace.ticket + `/${tool}`, newTickets)
    .then(({ data }) => data)
    .catch((error) => {
      actions.modals.open(modals.Dialog, {
        title: 'Ошибка',
        text: JSON.stringify({ error })
      })
      console.log(error)
    })
}

const fetchTickets = () => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.ticket + `/${tool}`)
    .then(({ data }) => data)
    .then((data) => {
      const tickets = convertPrice.toRub(data || [])

      reducers.marketplace.adminTicketPage.setTickets(tickets)
    })
    .catch((error) => console.log(error))
}


export default {
  setFetching,
  setTickets,
  fetchTickets,
}
